import { isSuperLollipopActive } from 'src/replicant/superLollipop/superLollipop.getters';
import { app } from '../../app';
import { BlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { mapGetPan } from '../../util/mapTools';
import { CubeEffect } from './CubeEffect';
import { IEffect } from './IEffect';
import { MergeEffect } from './MergeEffect';
import { user } from 'src/StateObserver';
import { SuperCubeEffect } from './SuperCubeEffect';

// types
//-----------------------------------------------------------------------------
export type CubeCubeComboEffectOptions = {
  subject: BlockEntity;
  pair: BlockEntity[];
  all: BlockEntity[];
};

/*
    cube+cube combo clear all basic blocks effect
*/
export class CubeCubeComboEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _options: CubeCubeComboEffectOptions;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: CubeCubeComboEffectOptions) {
    this._scene = scene;
    this._options = options;
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    const position = this._options.subject.c.position.mapPosition;

    // merge all blocks
    await new MergeEffect(this._scene, this._options.all, position).execute();

    // Execute the super cube effect if super lollipop is active
    if (isSuperLollipopActive(user())) {
      return new SuperCubeEffect(this._scene, {
        position,
        color: 'all',
      }).execute();
    }

    // execute cube effect
    return new CubeEffect(this._scene, {
      position,
      color: 'all',
    }).execute();
  }
}
